// src/components/EmotionAnalysisPanel/EmotionAnalysisPanel.styles.ts
import styled from "styled-components";
import { designTokens, getTypography } from "styles/designTokens";

interface RadarWrapperProps {
  backgroundImage: string;
}

/** 상단 Overview + Radar */
export const TopSection = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 32px;

  h2 {
    margin: 0px;
    ${getTypography("korean", "body1")}
    color: ${designTokens.colors.font.primary};
  }
`;

export const LeftSection = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 20px;
`;

/** 설명 텍스트 */
export const OverviewText = styled.p`
  margin: 0px;
  ${getTypography("korean", "body2")}
  color: ${designTokens.colors.font.tertiary};
`;

/** 비율 */
export const Ratio = styled.div`
  ${getTypography("korean", "body1")}
  color: ${designTokens.colors.font.primary};

  small {
    display: block;
    ${getTypography("korean", "body3")}
    color: ${designTokens.colors.font.tertiary};
  }
`;

/** 통계 테이블 */
export const StatsTable = styled.div`
  display: flex;
  border: 1px solid ${designTokens.colors.line.button};
  border-radius: 8px;
  overflow: hidden;
`;

export const StatCell = styled.div<{ isFirst: boolean }>`
  position: relative;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px 0px;
  gap: 9px;

  ${({ isFirst }) =>
    !isFirst &&
    `
    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 1px;
      height: 24px;
      background-color: ${designTokens.colors.line.button};
    }
  `}

  .label {
    display: block;
    ${getTypography("korean", "body4")}
    color: ${designTokens.colors.font.secondary};
  }
  .count {
    display: block;
    ${getTypography("korean", "body2")}
    color: ${designTokens.colors.font.primary};
  }
`;

/** 레이더 차트 래퍼 */
export const RadarWrapper = styled.div<RadarWrapperProps>`
  position: relative;
  width: 240px;
  height: 240px;

  canvas {
    position: relative;
    z-index: 2;
  }

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url(${(props) => props.backgroundImage});
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    z-index: 1;
    opacity: 0.5;
  }
`;

/** 핵심 감정 문장 */
export const KeySentencesSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  h3 {
    margin: 0;
    ${getTypography("korean", "body1")}
    color: ${designTokens.colors.font.primary};
  }
`;

export const KeySentenceItem = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 8px 16px;
  background: ${designTokens.colors.box.primary};
  border-radius: 8px;
  gap: 20px;

  .text {
    flex: 1;
    ${getTypography("korean", "body2")}
    color: ${designTokens.colors.font.tertiary};
  }
  .time {
    display: flex;
    align-items: center;
    height: 26px;
    ${getTypography("korean", "body4")}
    color: ${designTokens.colors.font.tertiary};
  }
`;

/** CTA 배너 */
export const CTABanner = styled.button`
  flex-shrink: 0;
  width: 100%;
  padding: 8px 16px;
  background: ${designTokens.colors.button.secondary};
  color: white;
  ${getTypography("korean", "body3")}
  border: none;
  cursor: pointer;
  text-align: center;
  gap: 4px;
`;

/** 액션 버튼 바 */
export const ActionBar = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
`;

/** 액션 버튼 */
export const ActionButton = styled.button`
  padding: 8px 12px;
  background: ${designTokens.colors.background.primary};
  border: 1px solid ${designTokens.colors.line.button};
  border-radius: 4px;
  ${getTypography("korean", "body3")}
  color: ${designTokens.colors.font.primary};
  cursor: pointer;

  &:hover {
    background: ${designTokens.colors.background.primary};
  }
`;
